<template>
  <el-table :data="tableOrderInfo" border>
    <el-table-column prop="ids" :label="$t('app.cardDetail.cardOrder.serialNumber')" align="center" width="60px"></el-table-column>
    <el-table-column prop="orderNum" :label="$t('app.cardDetail.cardOrder.orderNumber')" align="center" width="220"></el-table-column>
    <el-table-column prop="productName" :label="$t('app.cardDetail.cardOrder.productName')" align="center" width="220"></el-table-column>
    <el-table-column prop="productFlow" :label="$t('app.cardDetail.cardOrder.productFlow')" align="center"></el-table-column>
    <el-table-column prop="accountMoney" :label="$t('app.cardDetail.cardOrder.price')" align="center"></el-table-column>
    <el-table-column prop="currency" :label="$t('app.cardDetail.cardOrder.currency')" align="center" width="60" v-if="adminShow"></el-table-column>
    <el-table-column prop="orderStatus" :label="$t('app.cardDetail.cardOrder.status')" align="center"></el-table-column>
    <el-table-column prop="payType" :label="$t('app.cardDetail.cardOrder.payType')" align="center" v-if="adminShow"></el-table-column>
    <el-table-column prop="payTime" :label="$t('app.cardDetail.cardOrder.payTime')" align="center"></el-table-column>
    <el-table-column prop="remark" :label="$t('app.cardDetail.cardOrder.remark')" align="center" v-if="adminShow"></el-table-column>
  </el-table>
</template>
<script>
import { cardOrder } from "@/api/api.js"; //订单列表
export default {
  props: {
    iccid: {
      type: [String]
    }
  },
  computed: {
    adminShow(){
      return this.$store.getters.user.userType =='1'
    }
  },
  data() {
    return{
      tableOrderInfo:[],
    }
  },
  watch: {
    iccid() {
      this.initData();
    }
  },
  methods: {
    transferOrderStatus(status) {
      let obj = {
        1: this.$t('app.order.status.unpaid'),
        2: this.$t('app.order.status.paid'),
        3: this.$t('app.order.status.received'),
        4: this.$t('app.order.status.refunded')
      };
      return obj[status];
    },
    transferPayType(status) {
      let obj = {
        1: this.$t('app.order.pay.wechatH5'),
        2: this.$t('app.order.pay.wechat'),
        3:  this.$t('app.order.pay.balance'),
        4: this.$t('app.order.pay.system'),
        5: this.$t('app.order.pay.alipayH5'),
        6: this.$t('app.order.pay.paypal'),
        7: this.$t('app.order.pay.commission'),
        8: this.$t('app.order.pay.miniprogram'),
        9: this.$t('app.order.pay.unionpay'),
        10: this.$t('app.order.pay.stripe')
      };
      return obj[status];
    },
    // 获取订单列表的数据
    initData(){
      let params = {
        iccid:this.iccid
      };
      cardOrder(params).then(res =>{
        if(res.data.code == 200){
          this.tableOrderInfo = res.data.data;
          this.tableOrderInfo.map((item,index)=>{
            item.ids = index + 1;
            item.orderStatus = this.transferOrderStatus(item.orderStatus);
            item.payType = this.transferPayType(item.payType);
            if(item.productFlow == -1){
              item.productFlow = this.$t('app.common.enjoyment')
            }
          })
        }
      })
    },
  },
  created() {
  }
};
</script>

<style scoped lang="less">

</style>


